export default __webpack_public_path__ + "static/studycafe-office5-235e277077dfa28e2d88acab7e4aaa94.jpg";